import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { AvantorDialogsService } from '@shared/dialogs/avantor-dialogs-api';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';

@Component({
    selector: 'avantor-footer',
    templateUrl: './avantor-footer.html',
    styleUrls: ['./avantor-footer.scss'],
    standalone: true,
    imports: [CommonModule, SharedModule, FormsModule, MaterialsModule],
})
export class AvantorFooterComponent implements OnInit {


    currentSiteId: any;
    currentYear: any;
    currentOrgDetails: any;
    constructor(
        private avantorDialogs: AvantorDialogsService,
        private router: Router,
        private orgAndStockroomService: OrgAndStockroomService,

    ) { }

    ngOnInit(): void {
        this.currentOrgDetails = JSON.parse(this.orgAndStockroomService.getStockroomAndOrgName()!)?.organization;
        this.currentSiteId = JSON.parse(this.orgAndStockroomService.getStockroomAndOrgName()!)?.organization?.siteId;
        this.currentYear = new Date().getFullYear();
    }

    handleRedirectToHelp(): void {
        this.router.navigate(['/app/help']);
    }

    dialogTermsOfUse() {
        this.avantorDialogs.openDialogTermsOfUse();
    }

    openPrivacyPolicy() {
        if (this.currentOrgDetails.country.countryId == 'MYS') {
            this.currentSiteId = "us.vwr.com";
        }
        window.open(`https://${this.currentSiteId}/store/content/externalContentPage.jsp?path=/${this.currentSiteId}/en_GB/privacy.jsp`, '_blank');
    }

}
